import moment from 'moment/moment';

export const getNormalizedDate = date => (date ? moment(date).format('DD/MMM/YYYY') : 'N/A');
